export const classNameForLanguage = language =>
  ["ar"].includes(language) ? "rtl" : "";



// WEBPACK FOOTER //
// ./src/data_language_direction.js